import axios from "axios";
import { API_CONSTANT_MAP } from "@utils/routes";

export const SKILL = {
    ADD_SKILL: "ADD_SKILL",
    ADD_ROOT: "ADD_ROOT",
    REMOVE_ROOT: "REMOVE_ROOT",
    REMOVE_SKILL: "REMOVE_SKILL",
    ADD_LABEL: "ADD_LABEL",
    REMOVE_LABEL: "REMOVE_LABEL",
    ADD_PROTOCOL: "ADD_PROTOCOL",
    REMOVE_PROTOCOL: "REMOVE_PROTOCOL",
    FETCH_SKILLS: "FETCH_SKILLS",
    UPDATE_DAILY_RATE: "UPDATE_DAILY_RATE",
    RESET: "RESET_SKILLS",
    ERROR: "ERROR"
};

const error = error => ({
    type: SKILL.ERROR,
    error
});

export const fetchSkills = id => async dispatch => {
    try {
        const response = await axios.get(API_CONSTANT_MAP.skills.get(id));

        dispatch({
            type: SKILL.FETCH_SKILLS,
            skills: response.data
        });
    } catch (err) {
        dispatch(error(err.message));
    }
};

export const addSkill = skill => dispatch =>
    dispatch({
        type: SKILL.ADD_SKILL,
        skill
    });

export const updateRate = data => dispatch => dispatch({ type: SKILL.UPDATE_DAILY_RATE, data });

export const deleteSkill = id => dispatch => dispatch({ type: SKILL.REMOVE_SKILL, id });

export const addRoot = (payload, root) => dispatch =>
    dispatch({
        type: SKILL.ADD_ROOT,
        root,
        skill_id: payload.skill_technician_id
    });

export const removeRoot = payload => dispatch =>
    dispatch({
        type: SKILL.REMOVE_ROOT,
        skill_id: payload.skill_id,
        root_id: payload.root_id
    });

export const addProtocol = (payload, data) => dispatch =>
    dispatch({
        type: SKILL.ADD_PROTOCOL,
        data,
        mode: payload.mode,
        skill_id: payload.skill_id,
        root_id: payload.root_id,
        label_id: payload.label_id
    });

export const removeProtocol = payload => dispatch =>
    dispatch({
        type: SKILL.REMOVE_PROTOCOL,
        mode: payload.mode,
        skill_id: payload.skill_id,
        root_id: payload.root_id,
        label_id: payload.label_id,
        protocol_id: payload.protocol_id
    });

export const addLabel = (payload, data) => dispatch =>
    dispatch({
        type: SKILL.ADD_LABEL,
        data,
        skill_id: payload.skill_id,
        root_id: payload.root_id
    });

export const removeLabel = payload => dispatch =>
    dispatch({
        type: SKILL.REMOVE_LABEL,
        skill_id: payload.skill_id,
        root_id: payload.root_id,
        label_id: payload.label_id
    });

export const resetSkills = () => dispatch => {
    dispatch({ type: SKILL.RESET });
};
